/**
 * API Aggregator
 *
 * Exposes all API helpers and the core request utilities from this directory.
 * Prefer importing specific modules when possible, or use the default `api`
 * object for convenience in UI layers.
 */
// Export core functionality
export * from './core';

// Export all API modules by domain
export * from './accounts/usersApi';
export * from './accounts/authApi';
export * from './accounts/adminApi';
export * from './namespaces/namespacesApi';
export * from './content/templatesApi';
export * from './content/templateActionsApi';
export * from './content/videoTemplatesApi';
export * from './media/stockVideosApi';
export * from './media/stockVideoActionsApi';
export * from './campaigns/campaignsApi';
export * from './tools/toolsApi';
export * from './tags/tagsApi';
export * from './websites/websitesApi';
export * from './activity/activityApi';

// Export default objects from all modules
import core from './core';
import usersApi from './accounts/usersApi';
import authApi from './accounts/authApi';
import adminApi from './accounts/adminApi';
import namespacesApi from './namespaces/namespacesApi';
import templatesApi from './content/templatesApi';
import templateActionsApi from './content/templateActionsApi';
import campaignsApi from './campaigns/campaignsApi';
import toolsApi from './tools/toolsApi';
import tagsApi from './tags/tagsApi';
import activityApi from './activity/activityApi';

// Combined API object
const api = {
  ...core,
  users: usersApi,
  namespaces: namespacesApi,
  templates: templatesApi,
  templateActions: templateActionsApi,
  campaigns: campaignsApi,
  // Removed customTemplates namespace
  tools: toolsApi,
  auth: authApi,
  admin: adminApi,
  tags: tagsApi,
  activity: activityApi
};

export default api; 